import React, { useState, useEffect, useRef } from "react";
import { HiArrowRight, HiArrowLeft } from "react-icons/hi";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import { useLanguage } from "../../contexts/LanguageContext";
import "./homepage.css";

import zeroHunger from "../../assets/zero-hunger.png";
import goodHealth from "../../assets/good-health.png";
import decentWork from "../../assets/decent-work.png";
import responsibleConsumption from "../../assets/responsible-consumption.png";
import climateAction from "../../assets/climate-action.png";

import logoBSI from "../../assets/logo-bsi.png";

import ibcsd from "../../assets/logo_ibcsd.jpg";
import aoi from "../../assets/logo_aoi.jpg";
import foodcycle from "../../assets/logo_foodcycle.jpg";
import mesjiddoman from "../../assets/logomesjidoman.png";
import dayah from "../../assets/logo_dayah.png";
import badanpangannasional from "../../assets/logo_badan_pangan_nasional.png";
import grasp2030 from "../../assets/logo_grasp2030.png";
import ajnn from "../../assets/ajnn.png";
import anginAdvisor from "../../assets/angin-advisor.png";
import bandaAceh from "../../assets/banda-aceh.png";
import bankSampahUnsyiah from "../../assets/bank-sampah-unsyiah.jpg";
import bflf from "../../assets/bflf.jpg";
import bnn from "../../assets/bnn.png";
import darahUntukAceh from "../../assets/darah-untuk-aceh.jpg";
import dialeksis from "../../assets/dialeksis.png";
import diaspora from "../../assets/diaspora.png";
import dwp from "../../assets/dwp.png";
import educationUsa from "../../assets/education-usa.png";
import farmAlliance from "../../assets/farm-alliance.jpg";
import fimAceh from "../../assets/fim-aceh.png";
import foodBankBandung from "../../assets/food-bank-bandung.png";
import formad from "../../assets/formad.jpg";
import kingFriedChicken from "../../assets/king-fried-chicken.png";
import lamnyong from "../../assets/lamnyong.png";
import logoBemFP from "../../assets/logo-bem-fp.jpg";
import logoBritishCouncil from "../../assets/logo-british-council.png";
import logoGain from "../../assets/logo-gain.jpg";
import logoPMI from "../../assets/logo-pmi.png";
import mataGaruda from "../../assets/matagaruda.png";
import nutrihubAceh from "../../assets/nutrihub-aceh.png";
import pancacita from "../../assets/pancacita.jpg";
import phri from "../../assets/phri.png";
import rriBandaAceh from "../../assets/rri-banda-aceh.png";
import simpangLima from "../../assets/simpang-lima.jpg";
import sns from "../../assets/sns.png";
import solusiBangunAndalas from "../../assets/solusi-bangun-andalas.jpg";
import solusiBangunIndonesia from "../../assets/solusi-bangun-indonesia.jpg";
import teukuNyakArif from "../../assets/teuku-nyak-arif.png";
import tribunNews from "../../assets/tribunnews.png";
import uinArraniry from "../../assets/uin-arraniry.png";
import unicef from "../../assets/unicef.jpg";
import univAbulyatama from "../../assets/univ-abulyatama.png";
import unsyiah from "../../assets/unsyiah.png";
import unsyiahFP from "../../assets/unsyiah-fp.jpg";
import uptd from "../../assets/uptd.jpg";
import urbaniaAceh from "../../assets/urbania-aceh.jpg";
import viconesia from "../../assets/viconesia.jpg";
import yayasanBUMN from "../../assets/yayasan-bumn.png";
import yseali from "../../assets/yseali.png";

const partnerLogos = [
  { name: "GRASP 2030", logo: grasp2030 },
  { name: "Badan Pangan Nasional", logo: badanpangannasional },
  { name: "Dayah", logo: dayah },
  { name: "Mesjid Oman", logo: mesjiddoman },
  { name: "Food Cycle", logo: foodcycle },
  { name: "AOI", logo: aoi },
  { name: "ibcsd", logo: ibcsd },
  { name: "AJNN", logo: ajnn },
  { name: "ANGIN Advisory", logo: anginAdvisor },
  { name: "Kota Banda Aceh", logo: bandaAceh },
  { name: "Bank Sampah Unsyiah", logo: bankSampahUnsyiah },
  { name: "BFLF Indonesia", logo: bflf },
  { name: "BNN", logo: bnn },
  { name: "Darah untuk Aceh", logo: darahUntukAceh },
  { name: "Dialeksis", logo: dialeksis },
  { name: "Diaspora Global Aceh", logo: diaspora },
  { name: "DWP", logo: dwp },
  { name: "Education USA", logo: educationUsa },
  { name: "Farm Alliance", logo: farmAlliance },
  { name: "FIM Aceh", logo: fimAceh },
  { name: "Food Bank Bandung", logo: foodBankBandung },
  { name: "FORMAD", logo: formad },
  { name: "King Fried Chicken", logo: kingFriedChicken },
  { name: "Lamnyong Coffee", logo: lamnyong },
  { name: "BEM FP Unsyiah", logo: logoBemFP },
  { name: "British Council", logo: logoBritishCouncil },
  { name: "GAIN", logo: logoGain },
  { name: "PMI Kota Banda Aceh", logo: logoPMI },
  { name: "Mata Garuda LPDP Aceh", logo: mataGaruda },
  { name: "Nutrihub Aceh", logo: nutrihubAceh },
  { name: "Pancacita", logo: pancacita },
  { name: "PHRI", logo: phri },
  { name: "RRI Banda Aceh", logo: rriBandaAceh },
  { name: "Simpang Lima Grocery", logo: simpangLima },
  { name: "SNS", logo: sns },
  { name: "Solusi Bangun Andalas", logo: solusiBangunAndalas },
  { name: "Solusi Bangun Indonesia", logo: solusiBangunIndonesia },
  { name: "Teuku Nyak Arif", logo: teukuNyakArif },
  { name: "Tribun News", logo: tribunNews },
  { name: "UIN Ar-Raniry", logo: uinArraniry },
  { name: "UNICEF", logo: unicef },
  { name: "Univ. Abulyatama", logo: univAbulyatama },
  { name: "Unsyiah", logo: unsyiah },
  { name: "FP Unsyiah", logo: unsyiahFP },
  { name: "UPTD IRSAN", logo: uptd },
  { name: "Urbania Garden Aceh", logo: urbaniaAceh },
  { name: "VICOnesia", logo: viconesia },
  { name: "Yayasan BUMN", logo: yayasanBUMN },
  { name: "YSEALI", logo: yseali },
];

const legalityContent = {
  EN: {
    tag: "Legal Status",
    title: "Our\nLegality",
    subtitle:
      "Rumoh Pangan Aceh is officially registered as a foundation, committed to transparency and accountability in all its work.",
    established: "Established since June 2024",
    fields: "Social · Humanitarian · Environment · Religious",
    badgeLabel: "Officially Registered",
    items: [
      {
        num: "01",
        icon: "📜",
        label: "Notarial Deed",
        title: "Akta Notaris",
        detail: "YASIR ARFAN S.T., S.H., M.Kn.",
        value: "No. 5024100311100173",
        desc: "Officially notarized deed of establishment of Yayasan Rumoh Pangan Aceh, registered in October 2024.",
      },
      {
        num: "02",
        icon: "⚖️",
        label: "Ministerial Decree",
        title: "SK Kemenkumham RI",
        detail: "Tanggal 03 Oktober 2024",
        value: "AHU-0024689.AH.01.12.Tahun 2024",
        desc: "Decree of the Minister of Law and Human Rights of the Republic of Indonesia, officially legalizing the foundation.",
      },
      {
        num: "03",
        icon: "🏛️",
        label: "Foundation",
        title: "Yayasan Rumoh Pangan Aceh",
        detail: "Berdiri sejak Juni 2024",
        value: "Sosial · Kemanusiaan · Lingkungan · Keagamaan",
        desc: "Active in the fields of social welfare, humanitarian aid, environmental sustainability, and religious activities.",
      },
    ],
  },
  ID: {
    tag: "Status Hukum",
    title: "Legalitas\nKami",
    subtitle:
      "Rumoh Pangan Aceh secara resmi telah terdaftar sebagai yayasan, berkomitmen pada transparansi dan akuntabilitas dalam seluruh kegiatannya.",
    items: [
      {
        num: "01",
        icon: "📜",
        label: "Akta Notaris",
        title: "Akta Notaris",
        detail: "YASIR ARFAN S.T., S.H., M.Kn.",
        value: "No. 5024100311100173",
        desc: "Akta pendirian Yayasan Rumoh Pangan Aceh yang telah dinotariskan secara resmi, terdaftar pada Oktober 2024.",
      },
      {
        num: "02",
        icon: "⚖️",
        label: "SK Kemenkumham",
        title: "SK Kemenkumham RI",
        detail: "Tanggal 03 Oktober 2024",
        value: "AHU-0024689.AH.01.12.Tahun 2024",
        desc: "Keputusan Menteri Hukum dan Hak Asasi Manusia Republik Indonesia yang mengesahkan pendirian yayasan secara hukum.",
      },
      {
        num: "03",
        icon: "🏛️",
        label: "Yayasan",
        title: "Yayasan Rumoh Pangan Aceh",
        detail: "Berdiri sejak Juni 2024",
        value: "Sosial · Kemanusiaan · Lingkungan · Keagamaan",
        desc: "Aktif bergerak di bidang sosial, kemanusiaan, kelestarian lingkungan, dan kegiatan keagamaan di Aceh.",
      },
    ],
  },
};

const sdgsData = [
  {
    sdgNumber: "SDG 2",
    image: zeroHunger,
    alt: "Zero Hunger",
    desc: {
      EN: "Ending hunger, achieving food security, improving nutrition, reducing stunting rates, and promoting sustainable agriculture.",
      ID: "Mengakhiri kelaparan, mencapai ketahanan pangan, meningkatkan nutrisi, dan menurunkan angka stunting serta mendorong pertanian berkelanjutan.",
    },
  },
  {
    sdgNumber: "SDG 3",
    image: goodHealth,
    alt: "Good Health and Well-Being",
    desc: {
      EN: "Fulfilling community health and well-being through nutritious food access and healthy living promotion.",
      ID: "Pemenuhan kesehatan dan kesejahteraan masyarakat melalui akses pangan bergizi dan promosi hidup sehat.",
    },
  },
  {
    sdgNumber: "SDG 8",
    image: decentWork,
    alt: "Decent Work and Economic Growth",
    desc: {
      EN: "Helping farmers, breeders, and MSMEs in Aceh to grow sustainably and create dignified livelihoods.",
      ID: "Membantu petani, peternak, dan UMKM Aceh untuk bertumbuh secara berkelanjutan dan menciptakan penghidupan yang layak.",
    },
  },
  {
    sdgNumber: "SDG 12",
    image: responsibleConsumption,
    alt: "Responsible Consumption and Production",
    desc: {
      EN: "Promoting responsible patterns of production and consumption across the food supply chain.",
      ID: "Pola produksi dan konsumsi yang bertanggung jawab di sepanjang rantai pasok pangan.",
    },
  },
  {
    sdgNumber: "SDG 13",
    image: climateAction,
    alt: "Climate Action",
    desc: {
      EN: "Efforts to reduce food waste and loss that contribute to greenhouse gas emissions and climate change.",
      ID: "Upaya mengurangi sampah dan kehilangan pangan yang berdampak pada emisi gas rumah kaca dan perubahan iklim.",
    },
  },
];

// ─── Content (EN / ID) ────────────────────────────────────────────────────────
const content = {
  EN: {
    slides: [
      {
        image: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=1800&q=85",
        tag: "Food Security",
        title: "Improving Food Security in Aceh",
        subtitle:
          "Aceh has great agricultural potential but still relies heavily on imported food. Rumoh Pangan Aceh (RPA) tackles this as Aceh's first food bank—rescuing surplus food, empowering farmers, and building resilient local food systems.",
      },
      {
        image: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=1800&q=85",
        tag: "Farmer Empowerment",
        title: "Empowering Local Farmers",
        subtitle:
          "We train farmers to shift from conventional to regenerative agriculture, restoring soil health and reducing chemical dependence. We also connect them to fair, reliable markets for their produce.",
      },
      {
        image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=1800&q=85",
        tag: "Sustainable Distribution",
        title: "Affordable, Sustainable, and Nutritious Food for Communities",
        subtitle:
          "We support regenerative farming and local food systems to make healthy, affordable food more accessible—reducing Aceh's reliance on imports.",
      },
    ],
    video: {
      tag: "Profile Video",
      title: "Getting to Know\nRumoh Pangan Aceh",
      subtitle: "Bridging the gap between those who have more and those who need more",
    },
    clients: {
      tag: "Trusted By",
      title: "Our Partners\n& Clients",
      logos: partnerLogos,
    },
  },

  ID: {
    slides: [
      {
        image: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=1800&q=85",
        tag: "Ketahanan Pangan",
        title: "Meningkatkan Ketahanan Pangan untuk Aceh",
        subtitle:
          "Aceh punya potensi pertanian besar, namun masih bergantung pada pangan impor. Rumoh Pangan Aceh (RPA) hadir sebagai bank pangan pertama di Aceh—menyelamatkan surplus makanan, memberdayakan petani, dan membangun sistem pangan lokal yang tangguh.",
      },
      {
        image: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=1800&q=85",
        tag: "Pemberdayaan Petani",
        title: "Memberdayakan Petani Lokal",
        subtitle:
          "Kami melatih petani beralih ke pertanian regeneratif yang memulihkan kesehatan tanah dan mengurangi ketergantungan bahan kimia. Kami juga menghubungkan mereka dengan pasar yang adil dan andal.",
      },
      {
        image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=1800&q=85",
        tag: "Distribusi Berkelanjutan",
        title: "Makanan yang Terjangkau, Berkelanjutan, dan Bergizi untuk Masyarakat",
        subtitle:
          "Kami mendukung pertanian regeneratif dan sistem pangan lokal agar makanan sehat dan terjangkau lebih mudah diakses—mengurangi ketergantungan Aceh pada pangan impor.",
      },
    ],
    video: {
      tag: "Video Profil",
      title: "Mengenal Rumoh\nPangan Aceh",
      subtitle: "Menjembatani antara mereka yang berkelebihan dengan yang berkebutuhan",
    },
    clients: {
      tag: "Dipercaya Oleh",
      title: "Mitra &\nKlien Kami",
      subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore.",
      logos: partnerLogos,
    },
  },
};

// ─── useInView hook ────────────────────────────────────────────────────────────
const useInView = (ref, threshold = 0.15) => {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setInView(true); },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref, threshold]);
  return inView;
};

// ─── Section 1: Hero Carousel ──────────────────────────────────────────────────
const HeroCarousel = () => {
  const { language } = useLanguage();
  const slides = content[language].slides;

  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const timerRef = useRef(null);

  const startTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => setCurrent((p) => (p + 1) % slides.length), 5500);
  };

  useEffect(() => {
    startTimer();
    setTimeout(() => setLoaded(true), 100);
    return () => clearInterval(timerRef.current);
  }, []);

  // Reset ke slide 0 saat bahasa berubah
  useEffect(() => {
    setCurrent(0);
  }, [language]);

  const goTo = (i) => { setCurrent(i); startTimer(); };

  return (
    <section className="relative w-full h-[100vh] min-h-[600px] overflow-hidden">
      <div
        className="absolute left-0 top-0 h-full w-1 bg-[#c9862a] z-20"
        style={{
          transform: loaded ? "scaleY(1)" : "scaleY(0)",
          transformOrigin: "top",
          transition: "transform 1.2s cubic-bezier(0.16,1,0.3,1) 0.3s",
        }}
      />

      {slides.map((slide, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === current ? 1 : 0, zIndex: i === current ? 10 : 0 }}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="absolute inset-0 w-full h-full object-cover scale-105 transition-transform duration-[8000ms]"
            style={{ transform: i === current ? "scale(1)" : "scale(1.05)" }}
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#0d0c0a]/85 via-[#1a1a18]/60 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0d0c0a]/60 via-transparent to-transparent" />
        </div>
      ))}

      <div className="relative z-20 container h-full flex flex-col justify-end pb-24 pt-32 px-6 md:px-8">
        <div
          style={{
            opacity: loaded ? 1 : 0,
            transform: loaded ? "translateY(0)" : "translateY(24px)",
            transition: "all 0.9s ease 0.5s",
          }}
        >
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-10 bg-[#c9862a]" />
            <span className="text-[#c9862a] text-xs font-bold tracking-[4px] uppercase">
              {slides[current].tag}
            </span>
          </div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-[1.2] max-w-2xl md:max-w-3xl lg:max-w-4xl mb-6 tracking-tight">
            {slides[current].title}
          </h1>
          <p className="text-white/75 text-sm md:text-base leading-[1.8] max-w-xl lg:max-w-2xl mb-8">
            {slides[current].subtitle}
          </p>
        </div>

        <div className="flex items-center justify-between mt-12 border-t border-white/10 pt-6">
          <div className="flex gap-2">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => goTo(i)}
                className={`transition-all duration-300 rounded-full ${
                  i === current ? "w-8 h-2 bg-[#c9862a]" : "w-2 h-2 bg-white/30 hover:bg-white/60"
                }`}
              />
            ))}
          </div>
          <div className="flex items-center gap-4">
            <button
              onClick={() => goTo((current - 1 + slides.length) % slides.length)}
              className="w-10 h-10 border border-white/30 hover:border-[#c9862a] hover:bg-[#c9862a] text-white flex items-center justify-center transition-all duration-200"
            >
              <HiArrowLeft size={16} />
            </button>
            <span className="text-white/30 text-xs font-bold tracking-widest">
              {String(current + 1).padStart(2, "0")} / {String(slides.length).padStart(2, "0")}
            </span>
            <button
              onClick={() => goTo((current + 1) % slides.length)}
              className="w-10 h-10 border border-white/30 hover:border-[#c9862a] hover:bg-[#c9862a] text-white flex items-center justify-center transition-all duration-200"
            >
              <HiArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};


// ─── Section 2: Video ──────────────────────────────────────────────────────────
const VideoSection = () => {
  const { language } = useLanguage();
  const t = content[language].video;
  const ref = useRef(null);
  const inView = useInView(ref);

  return (
    <section ref={ref} className="bg-[#f7f3ec] py-24 px-4 relative overflow-hidden">
      <div className="absolute top-4 right-0 font-serif text-[160px] font-bold text-[#e8e0d0] leading-none select-none pointer-events-none opacity-60">
        VIDEO
      </div>

      <div className="container max-w-5xl mx-auto relative z-10">
        <div
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-6"
          style={{ opacity: inView ? 1 : 0, transform: inView ? "translateY(0)" : "translateY(24px)", transition: "all 0.8s ease" }}
        >
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-10 bg-[#c9862a]" />
              <span className="text-[#c9862a] text-xs font-bold tracking-[4px] uppercase">{t.tag}</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1a1a18] leading-tight">
              {t.title.split("\n").map((line, i) => (
                <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
              ))}
            </h2>
          </div>
          <p className="text-[#6b6456] text-base leading-relaxed max-w-xs md:text-right">
            {t.subtitle}
          </p>
        </div>

        <div className="flex items-center gap-4 mb-12">
          <div className="flex-1 h-px bg-[#e8e0d0]" />
          <div className="w-2 h-2 bg-[#c9862a] rotate-45" />
          <div className="flex-1 h-px bg-[#e8e0d0]" />
        </div>

        <div
          className="relative w-full overflow-hidden shadow-xl border border-[#e8e0d0]"
          style={{ paddingBottom: "56.25%", opacity: inView ? 1 : 0, transition: "opacity 0.9s ease 0.2s" }}
        >
          <iframe
            className="absolute inset-0 w-full h-full"
            src="https://www.youtube.com/embed/hf8hqEChiXU"
            title="Rumoh Pangan Aceh"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

// ─── Section: Map Location ───────────────────────────────────────────────────
const MapSection = () => {
  const { language } = useLanguage();
  const ref = useRef(null);
  const inView = useInView(ref);

  const mapContent = {
    EN: {
      tag: "Our Location",
      title: "Find Us",
      subtitle: "Visit Rumoh Pangan Aceh to see our work firsthand.",
    },
    ID: {
      tag: "Lokasi Kami",
      title: "Temukan Kami",
      subtitle: "Kunjungi Rumoh Pangan Aceh untuk melihat kerja kami secara langsung.",
    },
  };

  const t = mapContent[language];
  const coords = { lat: 5.599809540893842, lng: 95.35370443755096 };
  const mapUrl = `https://www.google.com/maps?q=${coords.lat},${coords.lng}&z=15&output=embed`;

  return (
    <section ref={ref} className="bg-[#f7f3ec] py-16 px-4 relative overflow-hidden">
      <div className="container max-w-5xl mx-auto">
        <div
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-6"
          style={{
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(24px)",
            transition: "all 0.8s ease",
          }}
        >
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-10 bg-[#c9862a]" />
              <span className="text-[#c9862a] text-xs font-bold tracking-[4px] uppercase">{t.tag}</span>
            </div>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1a1a18] leading-tight">
              {t.title}
            </h2>
          </div>
          <p className="text-[#6b6456] text-sm leading-relaxed max-w-xs md:text-right">
            {t.subtitle}
          </p>
        </div>

        <div
          className="relative w-full overflow-hidden shadow-xl border border-[#e8e0d0]"
          style={{ paddingBottom: "50%", opacity: inView ? 1 : 0, transition: "opacity 0.9s ease 0.2s" }}
        >
          <iframe
            className="absolute inset-0 w-full h-full"
            src={mapUrl}
            title="Lokasi Rumoh Pangan Aceh"
            frameBorder="0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="mt-6 flex items-center gap-3">
          <div className="w-3 h-3 bg-[#c9862a] rounded-full animate-pulse" />
          <p className="text-[#6b6456] text-sm font-medium">
            Lokasi Rumoh Pangan Aceh — {coords.lat.toFixed(6)}, {coords.lng.toFixed(6)}
          </p>
        </div>
      </div>
    </section>
  );
};

// ─── Section 3: Roles ──────────────────────────────────────────────────────────
const LegalitySection = () => {
  const { language } = useLanguage();
  const t = legalityContent[language];
  const ref = useRef(null);
  const inView = useInView(ref);
 
  return (
    <section ref={ref} className="bg-white py-24 px-4 relative overflow-hidden">
      {/* Watermark background */}
      <div className="absolute bottom-0 left-0 font-serif text-[130px] font-bold text-[#f0ece3] leading-none select-none pointer-events-none opacity-80 translate-y-6">
        {language === "EN" ? "LEGAL" : "LEGAL"}
      </div>
 
      <div className="container max-w-6xl mx-auto relative z-10">
 
        {/* ── Header ── */}
        <div
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6"
          style={{
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(24px)",
            transition: "all 0.8s ease",
          }}
        >
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-10 bg-[#c9862a]" />
              <span className="text-[#c9862a] text-xs font-bold tracking-[4px] uppercase">
                {t.tag}
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl font-bold text-[#1a1a18] leading-tight">
              {t.title.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i === 0 && <br />}
                </React.Fragment>
              ))}
            </h2>
          </div>
          <div className="flex flex-col items-start md:items-end gap-2">
            <p className="text-[#6b6456] text-base leading-relaxed max-w-sm md:text-right">
              {t.subtitle}
            </p>
            {/* Official badge */}
            <div className="flex items-center gap-2 mt-2 bg-[#f7f3ec] border border-[#e8e0d0] px-4 py-2">
              <div className="w-2 h-2 rounded-full bg-[#c9862a] animate-pulse" />
              <span className="text-[#c9862a] text-[11px] font-bold tracking-[2px] uppercase">
                {t.badgeLabel}
              </span>
            </div>
          </div>
        </div>
 
        {/* ── Divider ── */}
        <div className="flex items-center gap-4 mb-14">
          <div className="flex-1 h-px bg-[#e8e0d0]" />
          <div className="w-2 h-2 bg-[#c9862a] rotate-45" />
          <div className="flex-1 h-px bg-[#e8e0d0]" />
        </div>
 
        {/* ── Legal Cards ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.items.map(({ num, icon, label, title, detail, value, desc }, i) => (
            <div
              key={num}
              className="group border border-[#e8e0d0] p-8 flex flex-col hover:border-[#c9862a]/50 hover:shadow-lg transition-all duration-300 relative overflow-hidden bg-white"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(32px)",
                transition: `all 0.7s ease ${0.2 + i * 0.15}s`,
              }}
            >
              {/* Background number */}
              <div className="absolute top-3 right-4 font-serif text-7xl font-bold text-[#f0ece3] leading-none select-none group-hover:text-[#c9862a]/10 transition-colors duration-300">
                {num}
              </div>
 
              {/* Icon box */}
              <div className="w-16 h-16 bg-[#f7f3ec] border border-[#e8e0d0] group-hover:border-[#c9862a] group-hover:bg-[#c9862a]/5 flex items-center justify-center text-3xl mb-6 transition-all duration-300">
                {icon}
              </div>
 
              {/* Label tag */}
              <span className="text-[#c9862a] text-[10px] font-bold tracking-[3px] uppercase mb-2">
                {label}
              </span>
 
              {/* Title */}
              <h3 className="font-serif text-xl font-bold text-[#1a1a18] mb-3 leading-snug">
                {title}
              </h3>
 
              {/* Gold divider */}
              <div className="w-8 h-[2px] bg-[#c9862a] mb-4 transition-all duration-500 group-hover:w-16" />
 
              {/* Detail line */}
              <p className="text-[#a09880] text-[11px] font-medium tracking-wide mb-1">
                {detail}
              </p>
 
              {/* Value — registration number or fields */}
              <div className="bg-[#f7f3ec] border border-[#e8e0d0] px-3 py-2 mb-4 group-hover:border-[#c9862a]/30 transition-colors duration-300">
                <p className="text-[#1a1a18] text-xs font-bold tracking-wide leading-snug">
                  {value}
                </p>
              </div>
 
              {/* Description */}
              <p className="text-[#6b6456] text-sm leading-relaxed flex-1">
                {desc}
              </p>
            </div>
          ))}
        </div>
 
      </div>
    </section>
  );
};

// ─── Section 4: SDGs Section ─────────────────────────────────────────────────────────
const SdgsSection = () => {
  const { language } = useLanguage();
  const ref = useRef(null);
  const inView = useInView(ref);
 
  const sectionContent = {
    EN: {
      tag: "Global Commitment",
      title: "Our SDGs\nPriority",
      subtitle:
        "Rumoh Pangan Aceh aligns its work with five United Nations Sustainable Development Goals as a foundation for meaningful, lasting impact.",
    },
    ID: {
      tag: "Komitmen Global",
      title: "Prioritas\nSDGs Kami",
      subtitle:
        "Rumoh Pangan Aceh menyelaraskan kerjanya dengan lima Tujuan Pembangunan Berkelanjutan PBB sebagai landasan dampak yang bermakna dan berkelanjutan.",
    },
  };
 
  const t = sectionContent[language];
 
  return (
    <section ref={ref} className="bg-[#1a1a18] py-24 px-4 relative overflow-hidden">
      {/* Ambient glow */}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_20%_50%,rgba(201,134,42,0.07)_0%,transparent_50%),radial-gradient(circle_at_80%_50%,rgba(201,134,42,0.04)_0%,transparent_50%)]" />
 
      {/* Watermark */}
      <div className="absolute bottom-0 right-0 font-serif text-[120px] font-bold text-white/[0.03] leading-none select-none pointer-events-none">
        SDGs
      </div>
 
      <div className="container max-w-6xl mx-auto relative z-10">
 
        {/* ── Header ── */}
        <div
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6"
          style={{
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(24px)",
            transition: "all 0.8s ease",
          }}
        >
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-10 bg-[#c9862a]" />
              <span className="text-[#c9862a] text-xs font-bold tracking-[4px] uppercase">
                {t.tag}
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl font-bold text-[#f0ece3] leading-tight">
              {t.title.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i === 0 && <br />}
                </React.Fragment>
              ))}
            </h2>
          </div>
          <p className="text-[#a09880] text-base leading-relaxed max-w-sm md:text-right">
            {t.subtitle}
          </p>
        </div>
 
        {/* ── Divider ── */}
        <div className="flex items-center gap-4 mb-14">
          <div className="flex-1 h-px bg-[#3a3a34]" />
          <div className="w-2 h-2 bg-[#c9862a] rotate-45" />
          <div className="flex-1 h-px bg-[#3a3a34]" />
        </div>
 
        {/* ── SDG Cards ── */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {sdgsData.map(({ sdgNumber, image, alt, desc }, i) => (
            <div
              key={sdgNumber}
              className="group flex flex-col"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(32px)",
                transition: `all 0.7s ease ${0.15 + i * 0.12}s`,
              }}
            >
              {/* SDG Image */}
              <div className="relative overflow-hidden border border-[#3a3a34] group-hover:border-[#c9862a]/60 transition-colors duration-300">
                <img
                  src={image}
                  alt={alt}
                  className="w-full aspect-square object-cover group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
 
              {/* Description */}
              <div className="mt-4 flex flex-col gap-2 flex-1">
                <div className="w-6 h-[2px] bg-[#c9862a] group-hover:w-10 transition-all duration-400" />
                <p className="text-[#a09880] text-xs leading-relaxed group-hover:text-[#c8bfae] transition-colors duration-300">
                  {desc[language]}
                </p>
              </div>
            </div>
          ))}
        </div>
 
        {/* ── Bottom Note ── */}
        <div
          className="mt-16 border-t border-[#2e2e28] pt-8 flex items-center justify-center gap-4"
          style={{
            opacity: inView ? 1 : 0,
            transition: "opacity 0.8s ease 0.9s",
          }}
        >
          <div className="h-px w-10 bg-[#3a3a34]" />
          <span className="text-[#5a5a50] text-[11px] font-bold tracking-[3px] uppercase">
            {language === "EN"
              ? "United Nations Sustainable Development Goals"
              : "Tujuan Pembangunan Berkelanjutan Perserikatan Bangsa-Bangsa"}
          </span>
          <div className="h-px w-10 bg-[#3a3a34]" />
        </div>
      </div>
    </section>
  );
};

// ─── Section 5: Clients ────────────────────────────────────────────────────────
const ClientsSection = () => {
  const { language } = useLanguage();
  const ref = useRef(null);
  const inView = useInView(ref);

  const clientsContent = {
    EN: {
      tag: "Trusted By",
      title: "Our Partners\n& Clients",
      subtitle:
        "We are honoured to collaborate with organisations dedicated to building a stronger food ecosystem across Aceh and beyond.",
    },
    ID: {
      tag: "Dipercaya Oleh",
      title: "Mitra &\nKlien Kami",
      subtitle:
        "Kami bangga berkolaborasi dengan organisasi-organisasi yang berdedikasi membangun ekosistem pangan yang lebih kuat di Aceh dan sekitarnya.",
    },
  };

  const t = clientsContent[language];

  return (
    <section ref={ref} className="bg-[#f7f3ec] py-24 px-4">
      <div className="container max-w-6xl mx-auto">

        {/* ── Header ── */}
        <div
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6"
          style={{
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(24px)",
            transition: "all 0.8s ease",
          }}
        >
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-10 bg-[#c9862a]" />
              <span className="text-[#c9862a] text-xs font-bold tracking-[4px] uppercase">
                {t.tag}
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl font-bold text-[#1a1a18] leading-tight">
              {t.title.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  <span dangerouslySetInnerHTML={{ __html: line }} />
                  {i === 0 && <br />}
                </React.Fragment>
              ))}
            </h2>
          </div>
          <p className="text-[#6b6456] text-base leading-relaxed max-w-sm md:text-right">
            {t.subtitle}
          </p>
        </div>

        {/* ── Divider ── */}
        <div className="flex items-center gap-4 mb-12">
          <div className="flex-1 h-px bg-[#e8e0d0]" />
          <div className="w-2 h-2 bg-[#c9862a] rotate-45" />
          <div className="flex-1 h-px bg-[#e8e0d0]" />
        </div>

        {/* ── Logo Grid ── */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-3">
          {partnerLogos.map(({ name, logo }, i) => (
            <div
              key={name}
              title={name}
              className="
                bg-white border border-[#e8e0d0]
                flex flex-col items-center justify-center gap-2
                py-5 px-3
                hover:border-[#c9862a] hover:shadow-md
                transition-all duration-200 cursor-pointer group
              "
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(16px)",
                transition: `all 0.6s ease ${0.03 * i}s`,
              }}
            >
              {/* Logo image */}
              <div className="w-14 h-14 flex items-center justify-center overflow-hidden">
                <img
                  src={logo}
                  alt={name}
                  className="
                    max-w-full max-h-full object-contain
                    transition-all duration-300
                  "
                />
              </div>

              {/* Partner name */}
              <p className="text-[#6b6456] text-[10px] font-medium text-center leading-tight line-clamp-2 px-1">
                {name}
              </p>
            </div>
          ))}
        </div>

        {/* ── Footer count ── */}
        <div
          className="mt-10 flex items-center justify-center gap-3"
          style={{
            opacity: inView ? 1 : 0,
            transition: "opacity 0.8s ease 0.8s",
          }}
        >
          <div className="h-px w-12 bg-[#e8e0d0]" />
          <span className="text-[#a09880] text-xs font-bold tracking-[3px] uppercase">
            {partnerLogos.length} {language === "EN" ? "Partners" : "Mitra"}
          </span>
          <div className="h-px w-12 bg-[#e8e0d0]" />
        </div>
      </div>
    </section>
  );
};

export { ClientsSection };

// ─── Section 6: Donasi ────────────────────────────────────────────────────────
const DonasiSection = () => {
  const { language } = useLanguage();
  const ref = useRef(null);
  const inView = useInView(ref);

  const t = {
    EN: {
      tag: "Support Us",
      title: "Donation\nAccount",
      subtitle: "Your donation helps us continue our mission to strengthen food security across Aceh.",
      bankName: "Bank Syariah Indonesia",
      accountLabel: "Account Number",
      accountName: "Rekening Rumoh Pangan Aceh",
      copyBtn: "Copy",
      copiedBtn: "Copied!",
      note: "Every contribution, large or small, makes a real difference.",
    },
    ID: {
      tag: "Dukung Kami",
      title: "Rekening\nDonasi",
      subtitle: "Donasi Anda membantu kami melanjutkan misi memperkuat ketahanan pangan masyarakat Aceh.",
      bankName: "Bank Syariah Indonesia",
      accountLabel: "Nomor Rekening",
      accountName: "Rekening Rumoh Pangan Aceh",
      copyBtn: "Salin",
      copiedBtn: "Tersalin!",
      note: "Setiap kontribusi, besar maupun kecil, membuat perbedaan nyata.",
    },
  };

  const tx = t[language];
  const accountNumber = "7299665776";
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(accountNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section ref={ref} className="bg-white py-24 px-4 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 font-serif text-[130px] font-bold text-[#f0ece3] leading-none select-none pointer-events-none opacity-60 translate-y-4">
        DONASI
      </div>

      <div className="container max-w-4xl mx-auto relative z-10">

        {/* Header */}
        <div
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6"
          style={{ opacity: inView ? 1 : 0, transform: inView ? "translateY(0)" : "translateY(24px)", transition: "all 0.8s ease" }}
        >
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-10 bg-[#c9862a]" />
              <span className="text-[#c9862a] text-xs font-bold tracking-[4px] uppercase">{tx.tag}</span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl font-bold text-[#1a1a18] leading-tight">
              {tx.title.split("\n").map((line, i) => (
                <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
              ))}
            </h2>
          </div>
          <p className="text-[#6b6456] text-base leading-relaxed max-w-sm md:text-right">
            {tx.subtitle}
          </p>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-12">
          <div className="flex-1 h-px bg-[#e8e0d0]" />
          <div className="w-2 h-2 bg-[#c9862a] rotate-45" />
          <div className="flex-1 h-px bg-[#e8e0d0]" />
        </div>

        {/* Bank Card */}
        <div
          className="border border-[#e8e0d0] bg-[#f7f3ec] p-8 md:p-12 flex flex-col md:flex-row items-start md:items-center gap-8"
          style={{ opacity: inView ? 1 : 0, transform: inView ? "translateY(0)" : "translateY(24px)", transition: "all 0.8s ease 0.2s" }}
        >
          {/* BSI Icon */}
          <div className="w-36 flex items-center justify-center shrink-0">
            <img src={logoBSI} alt="BSI Logo" className="w-full h-full object-contain" />
          </div>

          {/* Info */}
          <div className="flex-1 min-w-0">
            <p className="text-[#a09880] text-[11px] font-bold tracking-[3px] uppercase mb-1">
              {tx.accountLabel}
            </p>
            <p className="text-[#00a39e] text-xs font-bold tracking-wide mb-1">{tx.bankName}</p>
            <p className="font-serif text-3xl md:text-4xl font-bold text-[#1a1a18] tracking-widest mb-1">
              {accountNumber}
            </p>
            <p className="text-[#6b6456] text-sm">{tx.accountName}</p>
          </div>

          {/* Copy button */}
          <button
            onClick={handleCopy}
            className={`shrink-0 flex items-center gap-2 px-6 py-3 text-sm font-bold tracking-wide border transition-all duration-200 ${
              copied
                ? "bg-[#c9862a] border-[#c9862a] text-white"
                : "bg-white border-[#e8e0d0] text-[#1a1a18] hover:border-[#c9862a] hover:text-[#c9862a]"
            }`}
          >
            {copied ? tx.copiedBtn : tx.copyBtn}
          </button>
        </div>

        {/* Note */}
        <div
          className="mt-6 flex items-center gap-3"
          style={{ opacity: inView ? 1 : 0, transition: "opacity 0.8s ease 0.4s" }}
        >
          <div className="w-2 h-2 bg-[#c9862a] rotate-45 shrink-0" />
          <p className="text-[#a09880] text-sm italic">{tx.note}</p>
        </div>

      </div>
    </section>
  );
};

// ─── Homepage ──────────────────────────────────────────────────────────────────
const Homepage = () => (
  <main className="overflow-x-hidden font-homepage">
    <Navbar />
    <section id="hero"><HeroCarousel /></section>
    <section id="about"><VideoSection /></section>
    <section id="location"><MapSection /></section>
    <section id="legality"><LegalitySection /></section>
    <section id="sdgs"><SdgsSection /></section>
    <section id="clients"><ClientsSection /></section>
    <section id="donasi"><DonasiSection /></section>
    <section id="footer"><Footer /></section>
  </main>
);

export default Homepage;